import { useTranslation } from "react-i18next";
import Link from "@/components/feature/LocaleLink";
import PageLayout from "@/components/feature/PageLayout";
import { useLang } from "@/lib/useLang";
import { CATEGORY_LABEL, SOLUTIONS, type SolutionCategory } from "@/data/solutions";

const CATEGORIES: SolutionCategory[] = ["security", "remote", "email", "equipment"];

export default function SolutionsPage() {
  const { t } = useTranslation();
  const lang = useLang();

  return (
    <PageLayout
      eyebrow="SOLUTIONS"
      title={t("solutions.title")}
      desc={t("solutions.desc")}
      seoTitle={t("seo.solutions.title")}
      seoDescription={t("seo.solutions.desc")}
    >
      <div className="space-y-14">
        {CATEGORIES.map((cat) => (
          <section key={cat} id={cat}>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6" data-reveal>
              {CATEGORY_LABEL[cat][lang]}
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-reveal data-reveal-stagger>
              {SOLUTIONS.filter((s) => s.category === cat).map((s) => {
                const text = s.text[lang];
                return (
                  <Link
                    key={s.slug}
                    to={`/solutions/${s.slug}`}
                    className="glow-card glow-card-light group flex flex-col rounded-lg overflow-hidden bg-background-100 border border-background-200 hover:border-primary-400 hover:bg-background-50 transition-all cursor-pointer"
                  >
                    {s.image && (
                      <div className="h-44 overflow-hidden bg-background-200">
                        <img
                          src={(lang === "en" && (s.cardImageEn || s.imageEn)) || s.cardImage || s.image}
                          alt={text.title}
                          loading="lazy"
                          decoding="async"
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                        />
                      </div>
                    )}
                    <div className="flex flex-col flex-1 p-6">
                    <div className="flex items-center justify-between mb-4">
                      <div className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                        <i className={`${s.icon} text-lg`}></i>
                      </div>
                      {s.comingSoon && (
                        <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-800 text-xs font-semibold">
                          {text.statusBadge ?? t("solutions.comingSoon")}
                        </span>
                      )}
                    </div>
                    <h3 className="font-heading font-bold text-lg text-foreground-950 mb-2">
                      {text.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed flex-1">{text.tagline}</p>
                    <div className="mt-5 pt-4 border-t border-background-200 flex items-center gap-2 text-primary-600 text-sm font-semibold group-hover:gap-3 transition-all">
                      {t("solutions.more")}
                      <i className="ri-arrow-right-line"></i>
                    </div>
                    </div>
                  </Link>
                );
              })}
            </div>
          </section>
        ))}
      </div>
    </PageLayout>
  );
}
